export const Settings = {
  REEL_COUNT: 5,
  JACKPOT_FEATURE: false,
  REEL_MULTIPLIER: 3,
  SYMBOL_HEIGHT: 210,
  SYMBOL_WIDTH: 210,
  SYMBOL_SIZE: 170,
  SYMBOL_COUNT: 13,
  SYMBOLS_VISIBLE: 3,
  SYMBOL_PADDING: 20,
  LOW_PAY_SYMBOLS: [3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
  REEL_GAP: 5,
  PADDING: 32,
  SPIN_SPEED: 18,
  TARGET_SYMBOL_COUNT: 5,
  BACK_OUT_EASE: 2,
  SPIN_DURATION: 400,
  SPIN_REEL_DELAY: 250,
  START_POSITION: -6,
  APP: {
    RGS_PROVIDER: "RedstoneRGS",
    DEFAULT_BET: 100,
    CURRENCY: "fun",
    GAME_NAME: "lucky-lady-charm",
  },
  REELS: [
    [2, 6, 6, 6, 5, 9, 12, 6, 6, 6],
    [7, 7, 7, 7, 7, 7, 7, 7, 7, 7],
    [8, 8, 8, 8, 8, 8, 8, 8, 8, 8],
    [9, 9, 9, 9, 9, 9, 9, 9, 9, 9],
    [11, 11, 11, 11, 11, 11, 11, 11, 11, 11],
  ],
  TEST_REELS: [
    [8, 3, 1],
    [9, 10, 8],
    [10, 7, 6],
    [9, 4, 7],
    [3, 4, 10],
  ],
  DEFAULT_SLOTFACE: [],
  LANGUAGES: [
    { value: "en", label: "EN" },
    { value: "sr-Latn", label: "SR" },
  ],
  STOP_DELAY_MANUAL: 50, // Delay between reels for manual stop
  STOP_DELAY_AUTO: 250, // Delay between reels for automatic stop
  AUTO_STOP_TIMEOUT: 500, // Time before automatic stop starts
  AUTO_PLAY_OPTIONS: [10, 25, 50, 75, 100],
};

export const AnimationSettings = {
  INCREMENT_DURATION: 4000,
  SPIN_DURATION: 1500,
  SPIN_SPEED: 16,
  STOP_DURATION: 0.2,
  ANIMATION_SPEED: 2000,
};

// settings.ts
export const WIN_CATEGORIES = [
  {
    name: "bigWin",
    min: 10000,
    max: 19999,
    level: "lvl1",
    duration: 4000,
  },
  {
    name: "megaWin",
    min: 20000,
    max: 29999,
    level: "lvl2",
    duration: 4000,
  },
  {
    name: "superWin",
    min: 30000,
    max: Infinity,
    level: "lvl3",
    duration: 4000,
  },
];

export const SimulationSettings = {
  SIMULATION_AVAILABLE: true,
  SIMULATION_SLOTFACE: [
    [12, 2, 3],
    [12, 4, 5],
    [12, 7, 8],
    [9, 10, 11],
    [0, 1, 2],
  ],
  SIMULATION_REELS: [
    [8, 12, 2, 3, 8],
    [11, 12, 4, 5, 9],
    [11, 12, 7, 8, 11],
    [2, 9, 10, 11, 5],
    [10, 0, 1, 2, 10],
  ],
};

export const APP_VERSION = "28.05.2025";
